<button
    matButton
    [type]="type"
    [disabled]="disabled"
    (click)="click($event)"
    class="kh-app-text-button"
>
    @if (icon) {
        <mat-icon>{{ icon }}</mat-icon>
    }
    <ng-content></ng-content>
    @if (iconRight) {
        <mat-icon iconPositionEnd>{{ iconRight }}</mat-icon>
    }
</button>
